import React from 'react';
import { StoreButtons, PostPurchaseFooter, postPurchaseLang } from './StoreButtons.jsx';

// Tela final do funil web — criado em 16/09/2026. Conforme decidido em
// App_Fitness_Especificacao.md (Regra permanente #4): depois de pagar
// aqui, a pessoa baixa o app de verdade e loga com a MESMA conta (mesmo
// email) — não construímos uma segunda experiência de treino dentro deste
// site. Atualizado em 06/10/2026: passo a passo + botões das lojas + rodapé
// (mesmos do e-mail de boas-vindas e da página /app).
const COPY = {
  pt: {
    title: 'Pagamento confirmado!',
    lead: (email) => `Sua assinatura já está ativa${email ? ` (${email})` : ''}. Enviamos um e-mail com o passo a passo.`,
    steps: [
      ['Baixe o FitClutch', 'Toque no botão abaixo para instalar o app na sua loja.'],
      ['Abra o app', 'Você vai ver a tela inicial do FitClutch.'],
      ['Entre com o e-mail da compra', 'Use o mesmo e-mail do pagamento e seu plano libera na hora.'],
    ],
  },
  en: {
    title: 'Payment confirmed!',
    lead: (email) => `Your subscription is active${email ? ` (${email})` : ''}. We sent you an e-mail with the steps.`,
    steps: [
      ['Download FitClutch', 'Tap the button below to install the app from your store.'],
      ['Open the app', 'You will see the FitClutch home screen.'],
      ['Sign in with your purchase e-mail', 'Use the same e-mail as the payment and your plan unlocks right away.'],
    ],
  },
};

export default function CheckoutSuccessScreen({ email }) {
  const lang = postPurchaseLang();
  const c = COPY[lang];
  return (
    <div className="phone-frame flex flex-col items-center justify-center safe-top safe-bottom px-6 py-10 text-center">
      <div className="w-16 h-16 rounded-full bg-cyan flex items-center justify-center text-2xl font-bold text-bg mb-6">
        ✓
      </div>
      <h1 className="font-display text-2xl font-extrabold mb-3">{c.title}</h1>
      <p className="text-ink-muted mb-6">{c.lead(email)}</p>

      <ol className="w-full text-left flex flex-col gap-4 mb-8">
        {c.steps.map(([title, text], i) => (
          <li key={title} className="flex items-start gap-3">
            <span className="shrink-0 w-8 h-8 rounded-full bg-cyan text-bg font-bold flex items-center justify-center">
              {i + 1}
            </span>
            <span>
              <span className="block font-bold">{title}</span>
              <span className="block text-sm text-ink-muted">{text}</span>
            </span>
          </li>
        ))}
      </ol>

      <StoreButtons lang={lang} />
      <PostPurchaseFooter lang={lang} />
    </div>
  );
}
